// The PS form keeps selected documents as `{ [caseDocTypeId]: true }` (the shape PECreate/PEUpdate
// map to the `documents: [{ caseDocTypeId }]` payload); the documents combobox works with ID arrays.
export type WorkOrderDocumentsValue = Record<string, boolean | undefined> | null | undefined;

export const documentsRecordToIds = (documents: WorkOrderDocumentsValue): string[] =>
  Object.entries(documents ?? {})
    .filter(([, selected]) => selected)
    .map(([id]) => id);

export const idsToDocumentsRecord = (ids: string[]): Record<string, boolean> =>
  Object.fromEntries(ids.map((id) => [id, true]));
